const initialState = {
  id: "",
  type: "",
  amount: 0,
  amountAvailable: null,
  applied: false,
  error: null,
};

export function loyaltyProgram(state = initialState, action) {
  let newState = {...state};
  if (action.type === 'FETCH_EVENT' || action.type === 'FETCH_LISTING_INFO') {
    if (action.data.loyaltyProgram) {
      const loyaltyProgram = action.data.loyaltyProgram;
      newState.id = loyaltyProgram.id;
      newState.type = loyaltyProgram.type;
      return newState
    }
    return state;
  } else if (action.type === 'SET_LOYALTY_AVAILABLE') {
    newState.amountAvailable = action.amount;
    return newState;
  } else if (action.type === 'SET_LOYALTY_AMOUNT') {
    newState.applied = action.amount > 0 || (newState.amount && !action.amount);
    newState.amount = action.amount;
    return newState;
  } else if (action.type === "RESERVATION_DATA_SET") {
    newState.amount = Number(action.reservation.attributes?.loyaltyAmount || 0);
    return newState;
  } else if(action.type === "RESERVATION_CLEARED") {
    newState.amount = 0;
    newState.amountAvailable = null;
    newState.applied = false;
    return newState;
  } else if (action.type === "SET_LOYALTY_ERROR") {
    newState.error = action.error;
    return newState;
  } else {
    return state;
  }
}
